<template>
  <b-modal
    id="cost-breakdown-modal"
    title="Cost breakdown"
    centered
    hide-footer
  >
    <template v-if="computationBreakdown">
      <div id="computations">
        <div class="d-flex justify-content-between">
          <div>Subtotal</div>
          <div>&#8369;{{ computationBreakdown.subtotal | currency }}</div>
        </div>
        <div class="d-flex justify-content-between mt-2">
          <div>VAT ({{ computationBreakdown.vat_value }})</div>
          <div>&#8369;{{ computationBreakdown.vat_amount | currency }}</div>
        </div>
        <div
          class="d-flex justify-content-between mt-2 text-success"
          v-if="computationBreakdown.discount_value"
        >
          <div>
            <span class="font-weight-bold">Discount</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="ml-1"
            >
              <path
                d="M8.96384 1.04729C8.66697 0.750337 8.26431 0.583464 7.84442 0.583374H2.16659C1.74666 0.583374 1.34393 0.750189 1.047 1.04712C0.750067 1.34405 0.583252 1.74678 0.583252 2.16671V7.84454C0.583342 8.26443 0.750215 8.66709 1.04717 8.96396L7.3805 15.2973C7.67742 15.5941 8.08008 15.7609 8.49992 15.7609C8.91976 15.7609 9.32242 15.5941 9.61934 15.2973L15.2972 9.61946C15.594 9.32254 15.7607 8.91988 15.7607 8.50004C15.7607 8.0802 15.594 7.67754 15.2972 7.38062L8.96384 1.04729ZM4.54159 6.12504C4.12155 6.12494 3.71877 5.95798 3.42184 5.6609C3.1249 5.36382 2.95815 4.96095 2.95825 4.54092C2.95836 4.12088 3.12531 3.7181 3.4224 3.42117C3.71948 3.12423 4.12235 2.95748 4.54238 2.95758C4.96241 2.95769 5.36519 3.12464 5.66213 3.42173C5.95906 3.71881 6.12582 4.12168 6.12571 4.54171C6.12561 4.96174 5.95865 5.36452 5.66157 5.66146C5.36449 5.95839 4.96162 6.12515 4.54159 6.12504Z"
                fill="#3BB56C"
              />
            </svg>

            <div id="discount-details">
              {{ computationBreakdown.discount_value }} off for
              {{
                billingRecurrenceLabels[computationBreakdown.billing_recurrence]
              }}
              subscription
            </div>
          </div>
          <div class="font-weight-bold">
            - &#8369;{{ computationBreakdown.discount_amount | currency }}
          </div>
        </div>
      </div>
      <div
        id="total-amount"
        class="d-flex justify-content-between mt-3 pt-3 border-top total-amount"
      >
        <div>Total Amount</div>
        <div>
          &#8369; {{ computationBreakdown.charge_total_amount | currency }}
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      billingRecurrenceLabels: {
        monthly: "monthly",
        quarterly: "quarterly",
        "bi-annual": "semi-annual",
        yearly: "annual",
      },
    };
  },
  computed: {
    ...mapGetters("myPlan", ["computationBreakdown"]),
  },
  filters: {
    currency(value) {
      if (!value) return 0;

      return Number(parseFloat(value).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
  },
};
</script>

<style lang="scss">
#cost-breakdown-modal {
  .modal-body {
    padding-top: 10px;
    padding-bottom: 10px;
    font-family: MainFontRegular, sans-serif;
  }
  .modal-title {
    width: 100%;
    font-size: 16px;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    text-align: center;
    border-bottom: 1px solid #eaeaeb;
    padding-bottom: 13px;
  }
  .modal-title::after {
    display: none;
  }
  #computations {
    font-size: 14px;
    color: #68737d;
  }
  .total-amount {
    color: #2f3941;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    font-size: 14px;
  }
  #discount-details {
    color: #68737d;
    font-size: 14px;
  }
}
</style>